export default "__VITE_ASSET__Cqcbv7DD__"